<template>
  <div class="alert">
    <el-alert class="base-alert" v-for="(msg,key) in tagMsg" :key="key" show-icon :visible="msg.content!=''" :type="msg.color" :closable="msg.closable=='1'" :data-suda="msg.suda" title="">
      <div class="zz-alert" v-html="msg.content"></div>
    </el-alert>
  </div>
</template>
<script>
export default {
  name: 'Alert',
  props: {
    tagMsg: {
      type: Array,
      default: () => []
    }
  },
  components: {},
  data: function () {
    return {}
  }
}

</script>
<style>
.alert {
  /*padding-top: 10px;*/
  width: 1200px;
  /*padding-bottom: 5px;*/
  margin-top: -1px;
}

.alert .base-alert {
  width: 1200px;
  min-height: 18px;
  padding:5px 30px;
  line-height: 28px;
  margin: 10px 0;
  border: 1px solid #FCAC0F;
  background-color:#FFF8E6;
  color:#FCAC0F;
  font-family: PingFangSC-Regular;
}

.alert .zz-alert {
  font-size: 12px;
  color: #666666;
  letter-spacing: 0;
  line-height:24px;
  margin-left: 5px;
}

.alert .zz-alert a {
  color: #2A60E4;
  text-decoration: none;
}
.alert .el-alert__icon.is-big{
  font-size: 12px;
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Alert.vue